import React from 'react';
import PropTypes from 'prop-types';
import Image from '@fec/frontend/elements/media/image/Image';
import ImageCaption from '@fec/frontend-aron/elements/media/ImageCaption/ImageCaption';

import './ImageFigure.scss';

const ImageFigure = ({ image }) => {
  const { ratio } = image;

  return (
    <figure className="imagefigure" data-app-image>
      <div className="imagefigure__image" style={{ aspectRatio: ratio }}>
        <Image image={image} />
      </div>
      <figcaption className="imagefigure__caption">
        <ImageCaption image={image} />
      </figcaption>
    </figure>
  );
};

ImageFigure.propTypes = {
  image: PropTypes.object,
};

export default ImageFigure;
